// import React from 'react'

// const ViewReturnList = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default ViewReturnList
import * as React from "react";
import {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
  useMemo,
} from "react";
import {
  AppBar,
  Typography,
  Button,
  Box,
  Breadcrumbs,
  Link,
  IconButton,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";
import { useTheme } from "@mui/material/styles";
import { PageDataContext } from "../../utils/common/PageDataContext";
import ViewDataGridGrn from "../../components/grid/ViewDataGridGrn";
import {
  ViewAppGrnData,
  ViewReturnGrnData,
} from "../../components/grid/GridDataGrn";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FilterGrnSearch from "../../components/grn/FilterGrnSearch";
import { externalgetApi } from "../../services/externalApis";
import { useSelector } from "react-redux";
import { GRN_API_02_2, GRN_API_17 } from "../../api/ApiModel";
import { CON_YES } from "../../utils/sys/Constants";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { FormatDate } from "../../utils/common/DateUtils";
import FilterReturnGrnSearch from "../../components/grn/FilterReturnGrnSearch";
import { AnyForNow, GrnFilterState } from "./types";
import { SEARCH_FIELDS } from "../../utils/sys/GrnSearchFeilds";
import {
  BUTTON_LABELS,
  GRN_BREADCRUMBS,
  GRN_VIEW_RETURN_LABELS,
  PAGE_TITLES,
} from "../../utils/sys/GrnLabels";
import { GRN_ROUTES } from "../../utils/sys/GrnRoutes";
import {
  createInitialFilters,
  useGrnStatusTypes,
  useWarehouseOptions,
} from "./hooks/useGrnFilters";
import {
  GRN_HISTORY_FILTER,
  GRN_RETURN_UI,
  GRN_STORAGE_KEYS,
  GRN_VIEW_RETURN_FILTER,
  PARAM_ID,
} from "../../utils/sys/GrnConstants";
import FilterSecrchByID from "../../components/grn/FilterSecrchByID";
import FilterReturnIdGrnSearch from "../../components/grn/FilterReturnIdGrnSearch";


type ViewType = "return" | "approved";

const ViewReturnList: React.FC = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const SYS_USER = useSelector((state: AnyForNow) => state.user) || {};
  const moduleParamJson = useSelector(
    (state: AnyForNow) => state.moduleParamJson
  );
  const moduleParamJsonArray = Array.isArray(moduleParamJson)
    ? moduleParamJson
    : Object.values(moduleParamJson || {});
  const { STAFFMAPLOCODE, USERNAME, COMPCODE } = SYS_USER.USER_PARAM || {};
  const PARAID = moduleParamJson && moduleParamJson[0]?.PARAID;
  const PARAVALUE = moduleParamJson && moduleParamJson[0]?.PARAVALUE;
  const rightSidebarRef = useRef<HTMLDivElement>(null);
  console.log("moduleParamJson", moduleParamJson);
  console.log("PARAID", PARAID);
  console.log("PARAVALUE", PARAVALUE);
  const [rightSidebarOpen, setRightSidebarOpen] = useState<boolean>(false);
  const [viewType, setViewType] = useState<ViewType>(
    GRN_VIEW_RETURN_FILTER.VIEW_TYPE_RETURN
  );

  const [allData, setAllData] = useState<AnyForNow[]>([]);
  const [returnData, setReturnData] = useState<AnyForNow[] | null>(null);
  const [filteredRows, setFilteredRows] = useState<AnyForNow[]>([]);
  const [filteredreturnRows, setFilteredreturnRows] = useState<AnyForNow[]>([]);
  const [filters, setFilters] = useState<GrnFilterState>(
    createInitialFilters(true)
  );
  const [loading, setLoading] = useState<boolean>(true);
  const isParaYes =
    moduleParamJsonArray.find(
      (item) => item.PARAID === PARAM_ID.APPROVAL_WORKFLOW
    )?.PARAVALUE === CON_YES;
  const warehouseOptions = useWarehouseOptions(COMPCODE);
  const returnExcludedAll =
    GRN_VIEW_RETURN_FILTER.RETURN_EXCLUDED_STATUSES_ALL as readonly string[];
  const returnExcludedDefault =
    GRN_VIEW_RETURN_FILTER.RETURN_EXCLUDED_STATUSES_DEFAULT as readonly string[];
  const returnEditDisabled =
    GRN_VIEW_RETURN_FILTER.RETURN_EDIT_DISABLED as readonly string[];
  const approvedStatusFilter = useCallback(
    (item: AnyForNow) =>
      String(item.trcatcode) === GRN_VIEW_RETURN_FILTER.TRCATCODE_APPROVED &&
      String(item.trsts) === GRN_VIEW_RETURN_FILTER.APPROVED_STATUS,
    []
  );
    const visibleStatuses = GRN_VIEW_RETURN_FILTER.VISIBLE_STATUSES as readonly string[];
  const { statusTypes: grnStatusTypes } = useGrnStatusTypes({
    filter: approvedStatusFilter,
    deps: [approvedStatusFilter],
  });
  const returnStatusFilter = useCallback(
    (item: AnyForNow) => {
      if (String(item.trcatcode) !== GRN_VIEW_RETURN_FILTER.TRCATCODE_RETURN) {
        return false;
      }
      if (isParaYes) {
        return !returnExcludedAll.includes(String(item.trsts));
      }
      return !returnExcludedDefault.includes(String(item.trsts));
    },
    [isParaYes, returnExcludedAll, returnExcludedDefault]
  );
  const { statusTypes: grnReturnStatusTypes } = useGrnStatusTypes({
    filter: returnStatusFilter,
    deps: [returnStatusFilter],
  });
  useEffect(() => {
    setPageData({
      title: PAGE_TITLES.PURCHASE_RETURN,
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, [setPageData]);

  const handleItemClick = (
    grncode: string,
    trsts: string,
     trcatcode:string, 
    actionText: string,
   
  ): void => {
    localStorage.removeItem(GRN_STORAGE_KEYS.RETURNED_PRODUCTS);
    if (actionText === GRN_VIEW_RETURN_FILTER.ACTION_VIEW_APPROVED) {
      navigate(GRN_ROUTES.VIEW_RETURN, {
        state: { grncode, trsts,trcatcode, statusCode: trsts, origin: GRN_VIEW_RETURN_FILTER.ORIGIN_RETURN },
      });
    }
      else if (actionText === GRN_VIEW_RETURN_FILTER.ACTION_VIEW_RETURN) {
        navigate(GRN_ROUTES.View_TEP_HISTORY, {
            state: { grncode, trsts,trcatcode, origin: GRN_VIEW_RETURN_FILTER.ORIGIN_RETURN },
        });
     

    } else if (actionText === BUTTON_LABELS.EDIT) {
      navigate(GRN_ROUTES.EDIT_RETURN, {
        state: { grncode, trsts, statusCode: trsts },
      });
    } else if (actionText === GRN_VIEW_RETURN_FILTER.ACTION_VIEW_RETURN) {
      navigate(GRN_ROUTES.VIEW_RETURN_GRN_DETAIL, {
        state: { grncode, trsts, origin: GRN_VIEW_RETURN_FILTER.ORIGIN_RETURN },
      });
    }
  };

  // const uniqueStatuses = [
  //   ...new Set(data?.map((item) => item.grnstatusremark).filter(Boolean)),
  // ];

  // Refs to prevent duplicate API calls
  const hasFetchedApprovedRef = React.useRef(false);
  const hasFetchedReturnRef = React.useRef(false);
  const grnStatusTypesRef = React.useRef<AnyForNow[]>([]);
  const grnReturnStatusTypesRef = React.useRef<AnyForNow[]>([]);
  const isInitialLoadRef = React.useRef(true);
  const loadingApprovedRef = React.useRef(false);
  const loadingReturnRef = React.useRef(false);

  // Update refs when status types change
  React.useEffect(() => {
    grnStatusTypesRef.current = grnStatusTypes;
  }, [grnStatusTypes]);

  React.useEffect(() => {
    grnReturnStatusTypesRef.current = grnReturnStatusTypes;
  }, [grnReturnStatusTypes]);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent): void {
      if (
        rightSidebarRef.current &&
        !rightSidebarRef.current.contains(event.target as Node) &&
        rightSidebarOpen
      ) {
        setRightSidebarOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [rightSidebarOpen]);

  // Consolidated: Fetch approved GRNs (GRN_API_02)
  const fetchSupplierListData = useCallback(async (): Promise<void> => {
    if (!COMPCODE || !STAFFMAPLOCODE) {
      return;
    }

    if (hasFetchedApprovedRef.current) {
      return;
    }

    try {
      hasFetchedApprovedRef.current = true;
      loadingApprovedRef.current = true;
      setLoading(true);
      const result = await externalgetApi(GRN_API_02_2, "GET", {
        COMPCODE,
        LOCCODE: STAFFMAPLOCODE,
        TRCATCODE: GRN_VIEW_RETURN_FILTER.TRCATCODE_APPROVED,
      });

  if (Array.isArray(result)) {
  const filteredResult = result.filter((item) =>
    visibleStatuses.includes(String(item.trsts))
  );

        
console.log("Approved GRN API result", result);
        const rowsWithId = filteredResult.map((item, index) => {
          const matchedStatus = grnStatusTypesRef.current.find(
            (status) => String(status.trsts) === String(item.trsts)
          );

          return {
            ...item,
            id: item.grncode || index,
            invoicedate: FormatDate(item.invoicedate) || null,
            endate: FormatDate(item.endate) || null,
            statusLabel:
              matchedStatus?.trenuserremark || GRN_BREADCRUMBS.STATUS_FALLBACK,
            statusColor:
              matchedStatus?.colorcode ||
              GRN_VIEW_RETURN_FILTER.STATUS_FALLBACK_COLOR_RETURN,
            invoicedateRaw: item.invoicedate,
            endateRaw: item.endate,
            ponumber: item.ponumber || "-",
            grnstatuscode: item.trsts,
            podate: FormatDate(item.podate) || null,
              Supplier: `${item.suprefcode} - ${item.suppliername}`,
          };
        });

        setAllData(rowsWithId);
        setFilteredRows(rowsWithId);
      } else {
        setAllData([]);
        setFilteredRows([]);
      }
    } catch (err) {
      console.error("Error fetching supplier list data:", err);
      hasFetchedApprovedRef.current = false;
    } finally {
      loadingApprovedRef.current = false;
      // Only set loading to false if return data is also not loading
      if (!loadingReturnRef.current) {
        setLoading(false);
      }
    }
  }, [COMPCODE, STAFFMAPLOCODE]);

  // Consolidated: Single function to fetch return GRNs (GRN_API_14)
  const fetchReturnGrnListData = useCallback(
    async (showAll = false): Promise<void> => {
      if (!COMPCODE || !STAFFMAPLOCODE) {
        return;
      }

      // Prevent duplicate calls unless forced (showAll=true means filters changed, so allow re-fetch)
      if (hasFetchedReturnRef.current && !showAll) {
        return;
      }

      try {
        hasFetchedReturnRef.current = true;
        loadingReturnRef.current = true;
        setLoading(true);
        const result = await externalgetApi(GRN_API_17, "GET", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,
          TRCATCODE: GRN_VIEW_RETURN_FILTER.TRCATCODE_RETURN,
        });

        if (!Array.isArray(result)) {
          setReturnData([]);
          setFilteredreturnRows([]);
          loadingReturnRef.current = false;
          // Only set loading to false if approved data is also not loading
          if (!loadingApprovedRef.current) {
            setLoading(false);
          }
          return;
        }

        const shouldIncludeAll =
          moduleParamJsonArray.filter(
            (item) => item.PARAID === PARAM_ID.APPROVAL_WORKFLOW
          )[0]?.PARAVALUE === CON_YES;

        let filteredResult;
        if (showAll || hasActiveFilters) {
          // Show all (excluding based on shouldIncludeAll)
          filteredResult = result.filter((item) => {
            if (shouldIncludeAll) {
              return !returnExcludedAll.includes(String(item.trsts));
            } else {
              return !returnExcludedDefault.includes(String(item.trsts));
            }
          });
        } else {
          // Default: only show trsts = 12
          filteredResult = result.filter(
            (item) =>
              String(item.trsts) ===
              GRN_VIEW_RETURN_FILTER.RETURN_DEFAULT_STATUS
          );
        }

        const rowsWithId = filteredResult.map((item, index) => {
          const matchedStatus = grnReturnStatusTypesRef.current.find(
            (status) => String(status.trsts) === String(item.trsts)
          );
          return {
            ...item,
            id: item.grnreturncode || item.grncode || index,
            invoicedate: FormatDate(item.invoicedate) || null,
            endate: FormatDate(item.endate) || null,
            statusLabel:
              matchedStatus?.trenuserremark || GRN_BREADCRUMBS.STATUS_FALLBACK,
            statusColor:
              matchedStatus?.colorcode ||
              GRN_VIEW_RETURN_FILTER.STATUS_FALLBACK_COLOR,
            invoicedateRaw: item.invoicedate,
            endateRaw: item.endate,
            ponumber: item.ponumber || "-",
            grnstatuscode: item.trsts,
            podate: FormatDate(item.podate) || null,
          };
        });

        setReturnData(rowsWithId);
        setFilteredreturnRows(rowsWithId);
      } catch (err) {
        console.error("Error fetching return GRN list data:", err);
        hasFetchedReturnRef.current = false;
      } finally {
        loadingReturnRef.current = false;
        // Only set loading to false if approved data is also not loading
        if (!loadingApprovedRef.current) {
          setLoading(false);
        }
      }
    },
    [COMPCODE, STAFFMAPLOCODE, moduleParamJsonArray]
  );

  const hasActiveFilters = Boolean(
    filters.fromDate ||
      filters.toDate ||
      filters.grnId ||
      filters.warehouse ||
      filters.status ||
      filters.grnreturncode ||
      filters.ponumber
  );

  // Initial load - fetch both when status types are loaded
  useEffect(() => {
    if (
      grnStatusTypes.length > 0 &&
      grnReturnStatusTypes.length > 0 &&
      isInitialLoadRef.current &&
      COMPCODE &&
      STAFFMAPLOCODE
    ) {
      isInitialLoadRef.current = false;
      fetchSupplierListData();
      fetchReturnGrnListData(false); // Default: show only trsts=12
    }
  }, [
    fetchSupplierListData,
    fetchReturnGrnListData,
    grnStatusTypes.length,
    grnReturnStatusTypes.length,
    COMPCODE,
    STAFFMAPLOCODE,
  ]);

  // Re-fetch return list when filters change (to show all vs filtered)
  useEffect(() => {
    if (hasFetchedReturnRef.current) {
      // Force re-fetch when filters change by passing showAll=true if hasActiveFilters
      fetchReturnGrnListData(hasActiveFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, hasActiveFilters]);

  useEffect(() => {
    if (!allData.length) {
      setFilteredRows([]);
      return;
    }

    let filtered = allData;

    // Common search across all relevant fields
    if (filters.searchValue) {
      const search = filters.searchValue.toLowerCase();
      filtered = filtered.filter((item) =>
        [
          item.grncode,
          item.ponumber,
          item.suprefcode,
          item.suppliername,
          item.invoiceno
        ]
          .map(field => field?.toString().toLowerCase())
          .some(val => val && val.includes(search))
      );
    }
    if (filters.warehouse) {
      filtered = filtered.filter(
        (item) => String(item.restcode) === filters.warehouse
      );
    }

    if (filters.status) {
      filtered = filtered.filter(
        (item) => String(item.grnstatuscode) === String(filters.status)
      );
    }

    // if (filters.fromDate) {
    //   filtered = filtered.filter(
    //     (item) => new Date(item.invoicedate) >= new Date(filters.fromDate)
    //   );
    // }

    // if (filters.toDate) {
    //   filtered = filtered.filter(
    //     (item) => new Date(item.endate) <= new Date(filters.toDate)
    //   );
    // }
  if (filters.fromDate && filters.toDate) {
  const from = new Date(filters.fromDate);
  const to = new Date(filters.toDate);

  const start = from < to ? from : to;
  const end = from < to ? to : from;

  filtered = filtered.filter(
    (item) => {
      const date = new Date(item.invoicedateRaw || item.endateRaw);
      return date >= start && date <= end;
    }
  );
} else if (filters.fromDate) {
  const from = new Date(filters.fromDate);
  filtered = filtered.filter(
    (item) => new Date(item.invoicedateRaw) >= from
  );
} else if (filters.toDate) {
  const to = new Date(filters.toDate);
  filtered = filtered.filter(
    (item) => new Date(item.endateRaw) <= to
  );
}


    setFilteredRows(filtered);
  }, [filters, allData]);

  const handleFilterChange = (newFilters: GrnFilterState): void => {
    setFilters(newFilters);
  };
  const approvedMenuItems = [
    {
      text: BUTTON_LABELS.RETURN,
      icon: <ModeEditOutlineOutlinedIcon />,
      onClick: (row: AnyForNow) =>
        handleItemClick(
          row.grncode,
          row.trsts,
          row.trcatcode,
          GRN_VIEW_RETURN_FILTER.ACTION_VIEW_APPROVED
        ),
    },
    {
      text: BUTTON_LABELS.VIEW_GRN,
      icon: <VisibilityOutlinedIcon />,
      onClick: (row: AnyForNow) =>
        handleItemClick(
          row.grncode,
          row.trsts,row.trcatcode,
          GRN_VIEW_RETURN_FILTER.ACTION_VIEW_RETURN
        ),
    },
  ];

  const MenuItems = [
    {
      text: BUTTON_LABELS.VIEW,
      icon: <VisibilityOutlinedIcon />,
      onClick: (row: AnyForNow) =>
        handleItemClick(
          row.grncode,
          row.trsts,
          row.trcatcode,
          GRN_VIEW_RETURN_FILTER.ACTION_VIEW_RETURN
        ),
    },
    {
      text: BUTTON_LABELS.RETURN,
      icon: <ModeEditOutlineOutlinedIcon />,
      onClick: (row: AnyForNow) =>
        handleItemClick(row.grncode, row.trsts,row.trcatcode, BUTTON_LABELS.EDIT),
      disabled: (row: AnyForNow) =>
        returnEditDisabled.includes(String(row.trsts)),
    },
  ];

  const toggleRightSidebar = (): void => {
    setRightSidebarOpen((prev) => !prev);
  };

  const [selectedRow, setSelectedRow] = useState<AnyForNow>(null);

  // Sort return rows by GRN Date in descending order (newest first)
  const sortedReturnRows = useMemo(() => {
    if (viewType !== GRN_VIEW_RETURN_FILTER.VIEW_TYPE_RETURN) {
      return filteredreturnRows;
    }
    return [...filteredreturnRows].sort((a, b) => {
      const dateA = a.endateRaw ? new Date(a.endateRaw).getTime() : 0;
      const dateB = b.endateRaw ? new Date(b.endateRaw).getTime() : 0;
      return dateB - dateA; // Descending order (newest first)
    });
  }, [filteredreturnRows, viewType]);

  // Update loading state based on current viewType and data availability
 

  return (
    <>
      <Box sx={styles.box_breadcrumb_view}>
        <Breadcrumbs
          separator={GRN_BREADCRUMBS.SEPARATOR}
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            {GRN_BREADCRUMBS.HOME}
          </Link>
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            {GRN_BREADCRUMBS.MANAGEMENT}
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
            {GRN_BREADCRUMBS.RETURN}
          </Link>
        </Breadcrumbs>
      </Box>

      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.vg_appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              size={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {ViewAppGrnData.name}
              </Typography>
            </Grid>

            <Grid size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }}>
              <Box
                sx={{
                  gap: 1,
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                {/* <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ ...styles.btn_primary }}
                  //remove hardcoded values and use constants
                  onClick={() => {
                    setViewType((prev) =>
                      prev === "return" ? "approved" : "return"
                    );
                    setFilters(createInitialFilters(true));
                  }}
                >
                  {viewType === GRN_VIEW_RETURN_FILTER.VIEW_TYPE_RETURN
                    ? GRN_VIEW_RETURN_LABELS.RETURN_LIST
                    : GRN_VIEW_RETURN_LABELS.APPROVED_LIST}
                </Button> */}
              </Box>
              <Box
                ref={rightSidebarRef}
                sx={{
                  position: "fixed",
                  top: GRN_RETURN_UI.SIDEBAR_TOP,
                  right: rightSidebarOpen
                    ? 0
                    : GRN_RETURN_UI.SIDEBAR_HIDDEN_OFFSET,
                  width: {
                    xs: GRN_RETURN_UI.SIDEBAR_WIDTH_MOBILE,
                    sm: GRN_RETURN_UI.SIDEBAR_WIDTH,
                  },
                  height: "100vh",
                  bgcolor: "background.default",
                  boxShadow: 3,
                  p: 1,
                  zIndex: 1,
                  transition: GRN_RETURN_UI.SIDEBAR_TRANSITION,
                  display: "flex",
                  flexDirection: "column",
                  overflowY: "auto",
                  "&::-webkit-scrollbar": { display: "none" },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    my: 1,
                  }}
                >
                  <Typography sx={styles.appbar_title}>
                    {GRN_VIEW_RETURN_LABELS.TABLE_APPROVED} 
                  </Typography>
                  <IconButton onClick={toggleRightSidebar} size="small">
                    <DisabledByDefaultOutlinedIcon />
                  </IconButton>
                </Box>
                <Divider />
                <Box
                  sx={{
                    flexGrow: 1,
                    overflowY: "auto",
                    scrollbarWidth: "none", // Hide scrollbar in Firefox
                    "&::-webkit-scrollbar": {
                      display: "none", // Hide scrollbar in WebKit browsers
                    },
                  }}
                ></Box>
              </Box>
            </Grid>
            {/* <Grid
              size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}
              sx={styles.vg_grid_new_button}
            >
              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                size="small"
                sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                onClick={goToCreateGrn}
              >
                New
              </Button>
            </Grid> */}
          </Grid>
        </AppBar>
        {/* <FilterGrnSearch /> */}
        {viewType === "approved" ? (
              <FilterSecrchByID
                 warehouseOptions={warehouseOptions}
                grnStatusTypes={grnStatusTypes}
                onFilterChange={handleFilterChange}
                  searchFields={SEARCH_FIELDS}
      
              />
        ) : (
           <FilterSecrchByID
                 warehouseOptions={warehouseOptions}
                grnStatusTypes={grnStatusTypes}
                onFilterChange={handleFilterChange}
                  searchFields={SEARCH_FIELDS}
      
              />
        )}

        <Box sx={styles.view_page_container}>
          <ViewDataGridGrn
            columns={
              viewType === GRN_VIEW_RETURN_FILTER.VIEW_TYPE_APPROVED
                ? ViewReturnGrnData.columns
                : ViewAppGrnData.columns
            }
            rows={
              viewType === GRN_VIEW_RETURN_FILTER.VIEW_TYPE_APPROVED
                ? sortedReturnRows
                : filteredRows 
            }
            menuItems={
              viewType === GRN_VIEW_RETURN_FILTER.VIEW_TYPE_APPROVED
                ? MenuItems
                : approvedMenuItems
            }
            tabletitle={
              viewType === GRN_VIEW_RETURN_FILTER.VIEW_TYPE_APPROVED
                ? GRN_VIEW_RETURN_LABELS.TABLE_RETURN
                : GRN_VIEW_RETURN_LABELS.TABLE_APPROVED
            }
            gridid={GRN_VIEW_RETURN_FILTER.GRID_ID}
            sx={styles.view_data_grid_page}
            grnStatusTypes={
              viewType === GRN_VIEW_RETURN_FILTER.VIEW_TYPE_APPROVED
                ? grnReturnStatusTypes
                : grnStatusTypes
            }
                clickableGrn={true}
                showCheckbox={false}
            onSelectionChange={undefined}
            grnReturnStatusTypes={undefined}
            selectionModel={undefined}
            loading={loading}
          />
        </Box>
      </Box>
    </>
  );
};

export default ViewReturnList;
